import { useEffect, useState } from 'react';
import { useMap } from 'react-naver-maps';
import { MIN_ZOOM_LEVEL } from '@/shared/consts';

const useIsZoomedOut = (): boolean => {
	const map = useMap();
	const [isZoomedOut, setIsZoomedOut] = useState(
		() => map.getZoom() < MIN_ZOOM_LEVEL,
	);

	useEffect(() => {
		const listener = map.addListener('zoom_changed', (zoom: number) => {
			setIsZoomedOut(zoom < MIN_ZOOM_LEVEL);
		});

		return () => {
			if (map) map.removeListener(listener);
		};
	}, [map]);

	return isZoomedOut;
};

export default useIsZoomedOut;
